export const useActionRefreshGaming = () => {
  const { onPlay, complete, actions } = useAbstractAction(
    'actionRefreshGaming',
    false,
    1000,
    [ActionRefreshData]
  );

  const route = useRoute();

  const isGamingPath = computed(() => {
    return route.path === `/${Sections.Gaming}`;
  });

  onPlay(async () => {
    if (isGamingPath.value) {
      await useGamingLoadFromNetwork();
      complete(true);
    } else {
      complete(true);
    }
  });
};
